import { createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";

// const initialState = {
//   admin: JSON.parse(localStorage.getItem("admin")) || null,
//   token: Cookies.get("adminToken") || null,
//   isAuthenticated: !!Cookies.get("adminToken"),

//   role: localStorage.getItem("role") || "",

//   permissions: JSON.parse(localStorage.getItem("permissions")) || {},
// };
const initialState = {
  admin: null,
  token: null,
  isAuthenticated: false,
  role: "",
  permissions: {},
     category_id:null,

    subcategory_id:null,
};
const authSlice = createSlice({
  name: "auth",
  initialState,

  reducers: {
    setLogin: (state, action) => {
      state.admin = action.payload.admin;
      state.token = action.payload.token;
      state.role = action.payload.role;
      state.permissions = action.payload.permissions;
      state.isAuthenticated = true;

    state.category_id=action.payload.category_id;

    state.subcategory_id=action.payload.subcategory_id;
    },

    // logout: (state) => {
    //   state.admin = null;
    //   state.token = null;
    //   state.role = "";
    //   state.permissions = {};
    //   state.isAuthenticated = false;

    //   localStorage.removeItem("admin");
    //   localStorage.removeItem("role");
    //   localStorage.removeItem("permissions");
    //   Cookies.remove("adminToken");
    // },
    logout: (state) => {
  state.admin = null;
  state.token = null;
  state.role = "";
  state.permissions = {};
  state.isAuthenticated = false;
  state.category_id=null;

state.subcategory_id=null;

  // Cookies.remove("adminToken");
  localStorage.removeItem("adminToken");
}
  },
});

export const { setLogin, logout } = authSlice.actions;
export default authSlice.reducer;